module.exports = __webpack_public_path__ + "img/prdays-logo.26bf9945.svg";